import { Fragment, FC } from 'react';
import { WithStyles, withStyles, createStyles } from '@material-ui/styles';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Theme, withConfig } from 'config';

const styles = createStyles({
  contentItem: {
    padding: '10px 0',
  },
  contentTitle: {
    display: 'block',
    fontFamily: 'Roboto',
    fontSize: 15,
  },
  contentSubtitle: {
    display: 'block',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 500,
    letterSpacing: '.5px',
  },
});

interface Props extends WithStyles<typeof styles>, RouteComponentProps<any> {
  spokenLanguagesList: string[];
  theme: Theme;
  label: string;
}

const ProfileSpokenLanguages: FC<Props> = ({ classes, spokenLanguagesList, theme, label }) => {
  return (
    <div className={classes.contentItem}>
      <span className={classes.contentTitle} style={{ color: theme.TEXT_SECONDARY }}>
        {label}:
      </span>
      {spokenLanguagesList.map((lang, idx) => (
        <Fragment key={idx}>
          <span className={classes.contentSubtitle} style={{ color: theme.TEXT_PRIMARY }}>
            {lang}
          </span>
        </Fragment>
      ))}
    </div>
  );
};

export default withStyles(styles)(withConfig(withRouter(ProfileSpokenLanguages)));
